/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `mp3` - mp3
 * `wav` - wav
 */
export type FormatEnum = (typeof FormatEnum)[keyof typeof FormatEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormatEnum = {
  mp3: "mp3",
  wav: "wav",
} as const;
